<script setup>
import { ref, provide } from 'vue'

const props = defineProps({
  marks: {
    type: Number,
    default: 0
  }
})

const activeIndex = ref(0)

const advance = () => {
  activeIndex.value + 1 === props.marks ?
    activeIndex.value = null :
    activeIndex.value++
}

const skip = () => {
  activeIndex.value = null
}

provide('coachmarks', {
  advance,
  skip
})
</script>

<template>
  <div>
    <slot :activeIndex="activeIndex" />
  </div>
</template>
